var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "OverviewRoot", staticClass: "overview-root" },
    [
      _vm._t("header", [
        _c("overview-header", {
          attrs: { overviewhash: _vm.overviewhash, actions: _vm.headerActions }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.bodyClass },
        [
          !_vm.showNewVersion
            ? _c(
                "div",
                { staticClass: "flex-level py-2" },
                [
                  _vm._t("backlink", [
                    _c("CompassBackForwardButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.back"),
                        link: "javascript:history.back();",
                        back: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("overview-nav", {
                      staticClass: "flex-right",
                      attrs: {
                        overviewhash: _vm.overviewhash,
                        identity: _vm.identity,
                        splitter: _vm.splitter,
                        "use-s-p-a-routing": true
                      }
                    })
                  ])
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            attrs: { id: "" + _vm.object.idName, type: "hidden" },
            domProps: { value: _vm.dataoverview.linkedid }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { id: "onOverview", type: "hidden", value: "Y" }
          }),
          _vm._v(" "),
          _vm._t("content", [
            _c(
              "div",
              { class: _vm.wrapperClass },
              [
                _vm.showNewVersion
                  ? _c(
                      "div",
                      { staticClass: "overview__navbar" },
                      [
                        _c("CompassSideNav", {
                          attrs: { menuItems: _vm.formattedNavItems }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "overview-navbar" },
                      [
                        _c(
                          "ul",
                          { staticClass: "well mt-0 mb-3" },
                          _vm._l(_vm.informationsNav, function(item, index) {
                            return _c(
                              "li",
                              { key: index },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "flex-level jc-space gray-100 fs-3 px-2 py-2 pointer hover-primary-05-bkg semibold",
                                    attrs: {
                                      to: _vm.routerLinkParams(item),
                                      "data-bot": item.databot,
                                      "active-class": "primary-50"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(item.label) +
                                        "\n                                "
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "icon-arrow-back dinlineb rotated-180 gray-60"
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "el-collapse",
                          {
                            staticClass:
                              "well sidemenu-overview sidemenu-overview-note__container",
                            class: _vm.activeNoteClass,
                            attrs: { accordion: "" },
                            model: {
                              value: _vm.activeNoteCollapse,
                              callback: function($$v) {
                                _vm.activeNoteCollapse = $$v
                              },
                              expression: "activeNoteCollapse"
                            }
                          },
                          [
                            _c(
                              "el-collapse-item",
                              {
                                attrs: { name: "sidemenu-overview-note" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "title",
                                    fn: function() {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.$l10n.__("Note")) +
                                              "\n                                "
                                          )
                                        ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ])
                              },
                              [
                                _vm._v(" "),
                                _vm.permissionsToEdit
                                  ? _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "click-outside",
                                            rawName: "v-click-outside.stop",
                                            value: _vm.submitNote,
                                            expression: "submitNote",
                                            modifiers: { stop: true }
                                          }
                                        ],
                                        on: {
                                          click: function($event) {
                                            return _vm.setActiveNoteClass(true)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c("RichText", {
                                              ref: "refNotesRichText",
                                              staticClass: "notes-richtext",
                                              attrs: {
                                                placeholder: _vm.$t.__(
                                                  "common.actions.write_note"
                                                ),
                                                options: _vm.optionsRichText,
                                                "is-custom": true,
                                                "show-rich-text-menu": false
                                              },
                                              model: {
                                                value: _vm.note,
                                                callback: function($$v) {
                                                  _vm.note = $$v
                                                },
                                                expression: "note"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm.richTextEditor
                                              ? _c("RichTextMenu", {
                                                  staticClass:
                                                    "notes-richtext-menu",
                                                  attrs: {
                                                    "editor-menu":
                                                      _vm.richTextEditor,
                                                    options: _vm.optionsRichText
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.canImportOldNote
                                          ? _c("CompassButton", {
                                              staticClass: "mt-1",
                                              attrs: {
                                                label: _vm.$t.__(
                                                  "overview.Overview.see_old_datas"
                                                ),
                                                type: "tertiary",
                                                size: "small",
                                                "left-icon": "attachment"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.openDialog(
                                                    "import-old-note"
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _c("div", {
                                      staticClass:
                                        "sidemenu-overview-note__content pr-3 my-2",
                                      domProps: { innerHTML: _vm._s(_vm.note) }
                                    })
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.noteIsEdited,
                                expression: "noteIsEdited"
                              }
                            ],
                            staticClass:
                              "sidemenu-overview-note__buttons flex-row mt-3"
                          },
                          [
                            _c("CompassButton", {
                              attrs: {
                                label: _vm.$t.__("common.actions.cancel"),
                                type: "secondary"
                              },
                              on: { click: _vm.cancelEditNote }
                            }),
                            _vm._v(" "),
                            _c("CompassButton", {
                              staticClass: "ml-3",
                              attrs: {
                                label: _vm.$t.__("common.actions.save")
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.submitNote($event)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.pluginsNav.length
                          ? [
                              _c("h2", [
                                _vm._v(_vm._s(_vm.$l10n.__("Modules")))
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-menu",
                                {
                                  staticClass:
                                    "well mt-0 mb-3 sidemenu-overview",
                                  attrs: { router: "" }
                                },
                                [
                                  _vm._l(_vm.pluginsNav, function(item, index) {
                                    return [
                                      item.subNav
                                        ? _c(
                                            "el-submenu",
                                            {
                                              key: index,
                                              attrs: { index: item.id },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "title",
                                                    fn: function() {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "semibold p-2 block"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.label)
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _vm._v(" "),
                                              _vm._l(item.subNav, function(
                                                subnav,
                                                subindex
                                              ) {
                                                return _c(
                                                  "el-menu-item",
                                                  { key: subindex },
                                                  [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        staticClass:
                                                          "flex-level jc-space gray-100 fs-3 pr-2 py-2 pointer hover-primary-05-bkg semibold",
                                                        attrs: {
                                                          to: _vm.routerLinkParams(
                                                            subnav
                                                          ),
                                                          "data-bot":
                                                            subnav.databot,
                                                          "active-class":
                                                            "primary-50"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              subnav.label
                                                            ) +
                                                            "\n                                            "
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "icon-arrow-back dinlineb rotated-180 gray-60"
                                                        })
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              })
                                            ],
                                            2
                                          )
                                        : _c(
                                            "el-menu-item",
                                            { key: index, staticClass: "p-0" },
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "flex-level jc-space gray-100 fs-3 px-2 py-2 pointer hover-primary-05-bkg semibold",
                                                  attrs: {
                                                    to: _vm.routerLinkParams(
                                                      item
                                                    ),
                                                    "data-bot": item.databot,
                                                    "active-class": "primary-50"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(item.label) +
                                                      "\n                                        "
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-arrow-back dinlineb rotated-180 gray-60"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                    ]
                                  })
                                ],
                                2
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.moreNav && _vm.moreNav.length > 0
                          ? _c(
                              "div",
                              _vm._l(_vm.moreNav, function(
                                component,
                                componentIndex
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: componentIndex,
                                    staticClass: "well mb-3 mt-0"
                                  },
                                  [
                                    component.component
                                      ? _c(
                                          component.component,
                                          _vm._b(
                                            { tag: "component" },
                                            "component",
                                            component.data,
                                            false
                                          )
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ],
                      2
                    ),
                _vm._v(" "),
                _vm.showNewVersion
                  ? _c(
                      "div",
                      { staticClass: "overview__container" },
                      [
                        _c("router-view", {
                          key: _vm.$route.path,
                          attrs: {
                            overviewhash: _vm.overviewhash,
                            more: _vm.currentNavButtons
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "overview__sidebar",
                            class: _vm.sidebarClass
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "overview__sidebar-toggle-wrapper"
                              },
                              [
                                _c(
                                  "CompassTooltip",
                                  {
                                    attrs: { arrow: false },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "content",
                                          fn: function() {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.tooltipLabelToggleButton
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "tooltip__shortcut typographies-paragraph-x-small-regular"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(_vm.shortcut) +
                                                      "\n                                        "
                                                  ),
                                                  _c("CompassIcon", {
                                                    attrs: {
                                                      icon: _vm.shortcutIcon,
                                                      size: "extra-small"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      2838431890
                                    )
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "overview__sidebar-toggle",
                                        class: _vm.toggleButtonClass,
                                        on: { click: _vm.toggleSidebar }
                                      },
                                      [
                                        _c("CompassIcon", {
                                          attrs: {
                                            icon: "caret-right",
                                            size: "small"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "overview__sidebar-wrapper" },
                              [
                                _c("OverviewNote", {
                                  attrs: {
                                    permissionsToEdit: _vm.permissionsToEdit,
                                    canImportOldNote: _vm.canImportOldNote,
                                    linkedid: _vm.dataoverview.linkedid,
                                    overviewType: _vm.currentOverviewType,
                                    linkedtype: _vm.dataoverview.linkedtype
                                  }
                                }),
                                _vm._v(" "),
                                _vm.dataoverview.linkedtype !== "people"
                                  ? _c("OverviewContactBlock", {
                                      attrs: {
                                        linkedid: _vm.dataoverview.linkedid,
                                        linkedtype: _vm.dataoverview.linkedtype
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.dataoverview.linkedtype !== "people"
                                  ? _c("OverviewCompanyBlock", {
                                      attrs: {
                                        linkedid: _vm.dataoverview.linkedid,
                                        linkedtype: _vm.dataoverview.linkedtype
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.moreNav && _vm.moreNav.length > 0
                                  ? _vm._l(_vm.moreNav, function(
                                      component,
                                      componentIndex
                                    ) {
                                      return _c(
                                        "DrawerAccordion",
                                        {
                                          key: componentIndex,
                                          attrs: {
                                            id: component.id,
                                            title: _vm.SellsyfyTitle(
                                              component.label
                                            )
                                          }
                                        },
                                        [
                                          component.component
                                            ? _c(
                                                component.component,
                                                _vm._b(
                                                  { tag: "component" },
                                                  "component",
                                                  component.data,
                                                  false
                                                )
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    })
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _c("router-view", {
                      key: _vm.$route.path,
                      attrs: {
                        overviewhash: _vm.overviewhash,
                        more: _vm.currentNavButtons
                      }
                    })
              ],
              1
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _vm.showPanel
        ? _c("OverviewPanel", {
            attrs: { value: _vm.panel, loading: _vm.panelLoading },
            on: { loaded: _vm.loadedPanel, close: _vm.closePanel }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showDialog
        ? _c("OverviewDialog", { attrs: { data: _vm.dialog } })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }